import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppBreadcrumbModule } from '@coreui/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AppMaterialModule } from '../../../app-material/app-material.module';
import { DatePickerModule } from '../../datePicker/date-picker/date-picker.module';
import { PdfExporterModule } from '../../pdf-exporter/pdf-exporter.module';
import { GroupStatisticsCardComponent } from './group-statistics-card.component';



@NgModule({
  declarations: [GroupStatisticsCardComponent],
  imports: [
    CommonModule,
    AppMaterialModule,
    ChartsModule,
    TranslateModule,
    AppBreadcrumbModule,
    TranslateModule,
    NgxDaterangepickerMd,
    DatePickerModule,
    PdfExporterModule
  ],
  exports: [GroupStatisticsCardComponent]
})
export class GroupStatisticsCardModule { }
